import PropTypes from 'prop-types'

const ManagePayrollPicHeader = ({ title }) => {
    return (
        <header className='header'>
            <h1>{title}</h1>
        </header>
    )
}

ManagePayrollPicHeader.defaultProps = {
    title: 'Manage Payroll PIC',
}

ManagePayrollPicHeader.propTypes = {
    title: PropTypes.string.isRequired,
}

export default ManagePayrollPicHeader
